module.exports = __webpack_public_path__ + "img/16.e761a57e.png";